import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { HeaderSetService } from './api/headerSet.service';
import { OperationSetService } from './api/operationSet.service';
import { OperationStatSetService } from './api/operationStatSet.service';
import { PPOrderSetService } from './api/pPOrderSet.service';
import { ReturnSetService } from './api/returnSet.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class OrderApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<OrderApiModule> {
        return {
            ngModule: OrderApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: OrderApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('OrderApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
